import React, { Component } from "react";
import { Link } from "react-router-dom";
import { Helmet } from 'react-helmet';
import './Toolstyle.css';
// import  * as actions from './Actions';
import Right from '../right/Right';
import Service from '../service/Service';

const service = new Service();

class Tools extends Component {
    constructor(props) {
        super(props);
        this.toolsData = require('./Tools.json');
    };

    componentDidMount() {
        // var iconLeft = (document.querySelector(".tools ul li").offsetWidth - document.querySelector(".image-container .icon").offsetWidth) / 2;
        // let i;
        // for (i = 0; i < document.querySelectorAll(".image-container .icon").length - 1; i++) {
        //     document.querySelectorAll(".image-container .icon")[i].style.left = iconLeft + "px";
        // }
    }

    render() {
        return (
            <main className="main-container">
                <Helmet
                    title="Fertility Calculator, Pregnancy Tracker & Parenting Tools - FirstCry Parenting"
                    meta={[
                        { "name": "description", "content": "FirstCry Parenting provides helpful online tools that provide information regarding most fertile days to conceive, ovulation calendar, pregnancy tracker and other parenting tools." },
                        { "name": "keywords", "content": "Fertility Calculator, Pregnancy Tracker & Parenting Tools - FirstCry Parenting" },
                        { "name": "atdlayout", "content": "tools" },
                    ]}
                />
                <div className="sub-container left">
                    <div className="tools data-container left">
                        {this.toolsData && this.toolsData.parenting[0] &&
                            <div className={this.toolsData.parenting[0].class}>
                                <div className="M14_42 tool_heading">{this.toolsData.parenting[0].toolstitle}</div>
                                <div className={this.toolsData.parenting[0].subclass}>
                                    <ul className="left">
                                        {this.toolsData.parenting[0]['submenu'] && this.toolsData.parenting[0]['submenu'].map((item, i1) => (
                                            <li key={i1} className="left" id={item.id}>
                                                <Link to={service.getRedirectUrl(item.href)}>
                                                    <div className="image-container">
                                                        <div className={item.class}>
                                                            <img src={`${item.url}`.replace(/\.jpg$/i, ".webp")} alt={item.title} title={item.title} />
                                                        </div>
                                                        <img className="icon" src={item.iconurl} alt={item.title} title={item.title} />
                                                    </div>
                                                    <div className="R14_61 tool_name_container">
                                                        <span className="tool_name">{item.title}</span>
                                                    </div>
                                                </Link>
                                            </li>
                                        ))}

                                    </ul>
                                </div>
                            </div>
                        }
                        {this.toolsData && this.toolsData.pragnency[0] &&
                            <div className={this.toolsData.pragnency[0].class}>
                                <div className="M14_42 tool_heading">{this.toolsData.pragnency[0].toolstitle}</div>
                                <div className={this.toolsData.pragnency[0].subclass}>
                                    <ul className="left">
                                        {this.toolsData.pragnency[0]['submenu'] && this.toolsData.pragnency[0]['submenu'].map((item, i1) => (
                                            <li key={i1} className="left" id={item.id}>
                                                <Link to={service.getRedirectUrl(item.href)}>
                                                    <div className="image-container">
                                                        <div className={item.class}>
                                                            <img src={`${item.url}`.replace(/\.jpg$/i, ".webp")} alt={item.title} title={item.title} />
                                                        </div>
                                                        <img className="icon" src={item.iconurl} alt={item.title} title={item.title} />
                                                    </div>
                                                    <div className="R14_61 tool_name_container">
                                                        <span className="tool_name">{item.title}</span>
                                                    </div>
                                                </Link>
                                            </li>
                                        ))}
                                    </ul>
                                </div>

                            </div>
                        }
                        {this.toolsData && this.toolsData.other[0] &&
                            <div className={this.toolsData.other[0].class}>
                                <div className="M14_42 tool_heading">{this.toolsData.other[0].toolstitle}</div>
                                <div className={this.toolsData.other[0].subclass}>
                                    <ul className="left">
                                        {this.toolsData && this.toolsData.other[0]['submenu'] && this.toolsData.other[0]['submenu'].map((item, i1) => (
                                            <li key={i1} className="left" id={item.id}>
                                                <Link to={service.getRedirectUrl(item.href)}>
                                                    <div className="image-container">
                                                        <div className={item.class}>
                                                            <img src={`${item.url}`.replace(/\.jpg$/i, ".webp")} alt={item.title} title={item.title} />
                                                        </div>
                                                        <img className="icon" src={item.iconurl} alt={item.title} title={item.title} />
                                                    </div>
                                                    <div className="R14_61 tool_name_container">
                                                        <span className="tool_name">{item.title}</span>
                                                    </div>
                                                </Link>
                                            </li>
                                        ))}
                                    </ul>
                                </div>
                            </div>
                        }
                    </div>
                </div>
                <Right url={this.props.match.url} />
            </main>
        )
    }
}

export default Tools;



// WEBPACK FOOTER //
// src/shared/tools/Tools.js